import {React ,useState}  from 'react'
import { ImCross } from 'react-icons/im'
import { AiFillCaretDown } from 'react-icons/ai'
export default function SelectToken(props) {


    return (
        <>

            <div className="popup-parent row mx-0 pt-5" >
                <div className="card g-card col-lg-4 col-md-6 col-11">
                    <div className="card-body py-4 w-100 mx-auto">
                        <div className="d-flex justify-content-between align-items-center border-bottom pb-3 pt-2 ">
                            <span className="fs-6">
                                Select Token
                            </span>
                            <ImCross className="cross-icon" onClick={() => { props.passState(0) }} style={{ fontSize: "14px", cursor: "pointer" }} />
                        </div>

                        <div className="row m-0 mt-4">
                            <input type="text" placeholder="NAME OR TOKEN ADDRESS " className="ws-inp text-center" />
                        </div>

                        <div className="d-flex align-items-center justify-content-between mt-3">
                            <img src={process.env.PUBLIC_URL + "/assets/images/ps-1.png"} className="logo-rounded-small" alt="" />
                            <img src={process.env.PUBLIC_URL + "/assets/images/ps-2.png"} className="logo-rounded-small" alt="" />
                            <img src={process.env.PUBLIC_URL + "/assets/images/ps-3.png"} className="logo-rounded-small" alt="" />
                            <img src={process.env.PUBLIC_URL + "/assets/images/ps-4.png"} className="logo-rounded-small" alt="" />
                            <img src={process.env.PUBLIC_URL + "/assets/images/ps-5.png"} className="logo-rounded-small" alt="" />
                            <img src={process.env.PUBLIC_URL + "/assets/images/ps-6.png"} className="logo-rounded-small" alt="" />
                        </div>

                        <div className="d-flex justify-content-between align-items-center border-bottom pb-3 pt-4 ">
                            <span className="fs-6">
                                Token Name
                            </span>
                            <AiFillCaretDown className="cross-icon" style={{ fontSize: "14px", cursor: "pointer" }} />
                        </div>

                        <div className="d-flex flex-column scroll-popup mt-2">
                            <div className="d-flex align-items-center pt-4">
                                <img src={process.env.PUBLIC_URL + "/assets/images/ps-1.png"} className="logo-rounded-small" alt="" />
                                <span className="text-faded text-small text-uppercase ps-3 fw-600">TOKEN NAME </span>
                            </div>
                            <div className="d-flex align-items-center pt-4">
                                <img src={process.env.PUBLIC_URL + "/assets/images/ps-2.png"} className="logo-rounded-small" alt="" />
                                <span className="text-faded text-small text-uppercase ps-3 fw-600">TOKEN NAME </span>
                            </div>
                            <div className="d-flex align-items-center pt-4">
                                <img src={process.env.PUBLIC_URL + "/assets/images/ps-3.png"} className="logo-rounded-small" alt="" />
                                <span className="text-faded text-small text-uppercase ps-3 fw-600">TOKEN NAME </span>
                            </div>
                            <div className="d-flex align-items-center pt-4">
                                <img src={process.env.PUBLIC_URL + "/assets/images/ps-4.png"} className="logo-rounded-small" alt="" />
                                <span className="text-faded text-small text-uppercase ps-3 fw-600">TOKEN NAME </span>
                            </div>
                            <div className="d-flex align-items-center pt-4">
                                <img src={process.env.PUBLIC_URL + "/assets/images/ps-5.png"} className="logo-rounded-small" alt="" />
                                <span className="text-faded text-small text-uppercase ps-3 fw-600">TOKEN NAME </span>
                            </div>
                            <div className="d-flex align-items-center pt-4">
                                <img src={process.env.PUBLIC_URL + "/assets/images/ps-6.png"} className="logo-rounded-small" alt="" />
                                <span className="text-faded text-small text-uppercase ps-3 fw-600">TOKEN NAME </span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )

}
